import React, { forwardRef } from "react";
const SvgCloseMini = (props, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m9.5 2.5-7 7m0-7 7 7", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgCloseMini);
export default ForwardRef;
